// extracted by mini-css-extract-plugin
module.exports = {"container":"fade-in-image_container__I8Gya"};